var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#BD411D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 11.4C8.8 11.8418 8.44183 12.2 8 12.2C7.55817 12.2 7.2 11.8418 7.2 11.4C7.2 10.9582 7.55817 10.6 8 10.6C8.44183 10.6 8.8 10.9582 8.8 11.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15608 4.39635C7.26979 4.27129 7.43098 4.2 7.6 4.2H8.4C8.56902 4.2 8.73021 4.27129 8.84392 4.39635C8.95763 4.5214 9.01332 4.68862 8.9973 4.85689L8.5973 9.05689C8.56797 9.36483 8.30933 9.6 8 9.6C7.69067 9.6 7.43203 9.36483 7.4027 9.05689L7.0027 4.85689C6.98668 4.68862 7.04237 4.5214 7.15608 4.39635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.f5f8d1138c2e2c8e522f320151a5d086.svg";
export { ForwardRef as ReactComponent };